<div class="ptf-work" uppDataid="ptf-work">
    <div class="ptf-work__body">
        <div
            *ngIf="!FloorReady"
            class="ptf-work__loading"
            uppDataid="ptf-work-loading"
        >
            <ion-spinner name="crescent"></ion-spinner>
            <p>{{ tr('@ptf_work_loading') }}</p>
        </div>

        <ng-container *ngIf="FloorReady">
        <div
            class="ptf-work__pane"
            [hidden]="!IsTab('tables') || HideTabs"
            uppDataid="ptf-work-pane-tables"
        >
            <upp-pinpad-tables [work]="this"></upp-pinpad-tables>
        </div>

        <div
            *ngIf="TicketsMounted && ticketsTpl"
            class="ptf-work__pane"
            [hidden]="!IsTab('tickets') || HideTabs"
            uppDataid="ptf-work-pane-tickets"
        >
            <ng-container
                *ngTemplateOutlet="ticketsTpl; context: { $implicit: this }"
            ></ng-container>
        </div>
        </ng-container>
        <!-- Ticket detail + cart are siblings of the home panel (hosted by home). -->
    </div>
</div>
